import { Component, OnInit } from '@angular/core';

@Component({ selector: 'app-internships', templateUrl: './internships.component.html', styleUrls: ['./internships.component.scss'] })
export class InternshipsComponent implements OnInit { constructor() { } ngOnInit(): void { } }
